<template>
    <div id="catalog">
        <headers :title='titles'></headers>
        <loadingS v-if='loading'></loadingS>
        <noResouse v-if='noResouse' text="本课无一类生字"></noResouse>
        <div class="content" v-if='!loading'>
            <div class="list-wrap">
                <div class="lists" v-for="item, index in dataList" :key="item.ch_code">
                    <div class="list_title" v-if="item.chapter_data.length">{{ item.ch_Name }}</div>
                    <dl class="list">
                        <dd v-for="d, inx in item.chapter_data">
                            <span class="recom" v-html="d.content"></span>
                            <!-- <span class="already" v-if='true'>已发过</span> -->
                            <i @click="selected(d, index, inx)"
                                :class="{ 'icon-fangxingkuang': !d.active, 'icon-fangxing': d.active }">
                                <div v-if='d.active'>移除</div>
                                <div v-else>加入</div>
                            </i>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <div class="foot" v-if='!loading'>
            <div class="bottom_btn clearfix">
                <div class="left_btn">
                    <i></i>
                    <span>已选（{{ num }}项）</span>
                </div>
                <div v-if='num == 0' :class="['right_btn', { 'able': num > 0, 'disable': num == 0 }]">去发布</div>
                <div v-else :class="['right_btn', { 'able': num > 0, 'disable': num == 0 }]" @click="toSend">去发布</div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue'

export default {
    data () {
        return {
            sid: this.$route.params.sid,
            type: this.$route.params.type, //1:课文预习 2同步习题 3单元复习 4高频错题 5生词听写 6 课外阅读
            dataList: [],
            titles: '资源预览',
            qid: [], //所选的列表的id
            loading: true, //加载图
            noResouse: false, //没有资源
            num: 0,
            unclick: false, //防止双击
            dept_type: null,//1:小学，2：初中
        }
    },
    created () {
        console.log(this.$store.state.qualityStation.sfchapterid)
        let _sendok = localStorage.getItem('chinese_send_ok');
        if (_sendok == 1) {
            this.$router.go(-1);//发布过返回选内容
            return;
        }
        let that = this;
        let cid = that.cid;
        this.$http.post(API_URL_TASK_API + '/szyz/send/sync_words_preview', {
            code: cid
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                if (res.data.data.length) {
                    this.dataList = this.dataList.concat(res.data.data);
                    this.dept_type = res.data.dept_type;
                    let tig = 0;
                    this.dataList.forEach(function (item, index) {
                        that.num = that.num + item.chapter_data.length
                        item.chapter_data.forEach(d => {
                            d.active = true;
                        })
                        if (!item.chapter_data.length) {
                            tig++;
                        }
                    });
                    if (tig == this.dataList.length) {
                        this.noResouse = true
                    }
                } else {
                    this.noResouse = true
                }
            } else {
                this.noResouse = true
            }
        }).finally((res) => {
            this.loading = false
        })
    },
    components: {
        headers,
        loadingS,
        noResouse
    },

    computed: {
        cid () {
            return this.$store.state.qualityStation.sfchapterid.join(',')
        }
    },
    destroyed () {

    },
    methods: {
        goBack () {
            this.$router.go(-1)
        },
        toSend () {
            let that = this;
            if (this.num > 100) {
                layer.alert('最多发送100个生词作业，请先移除部分生词。');
                return false;
            }
            if (!this.unclick) {
                this.dataList.forEach(function (item, index) {
                    item.chapter_data.forEach((i, l) => {
                        if (i.active) {
                            that.qid.push(i.id)
                        }
                    })
                });
                this.unclick = true;
            }
            this.$store.commit('setszyzreleaseid', this.qid);
            this.$router.push('/qualityStation/release/11/1?dept_type=' + this.dept_type);
        },
        selected (d, index, inx) {
            if (!d.active) {
                this.num += 1
            } else {
                this.num -= 1
            }
            d.active = !d.active;
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#catalog {
    min-height: 100vh;

    .content {
        padding-bottom: 2.8rem;

        .prompting {
            position: relative;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 24px / $ppr;
            color: #5e89ef;
            text-align: center;
            background-color: #fff;

            i {
                display: block;
                position: absolute;
                top: 36px / $ppr;
                right: 40px / $ppr;
                color: #cbcbcb;
            }
        }

        .list-wrap {
            .lists {
                background-color: #fff;
                margin-bottom: 24px / $ppr;
            }

            .list_title {
                padding-left: 24px / $ppr;
                height: 96px / $ppr;
                line-height: 96px / $ppr;
                font-size: 30px / $ppr;
                color: #333;
                font-weight: bold;
            }

            .list {
                background-color: #fff;

                dt {
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #333;
                    //font-weight: bold;
                    border-top: 1px / $ppr solid #e8e8e8;
                }

                dd {
                    position: relative;
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #999;
                    border-top: 1px / $ppr solid #e8e8e8;

                    i {
                        display: inline-block;
                        position: absolute;
                        top: 20px / $ppr;
                        font-size: 40px / $ppr;

                        &.icon-fangxingkuang {
                            top: 20px / $ppr;
                            text-align: center;
                            line-height: 48px / $ppr;
                            height: 48px / $ppr;
                            width: 122px / $ppr;
                            right: 24px / $ppr;
                            border: 1px / $ppr solid #5e89ef;
                            color: #5e89ef;
                            border-radius: 50px / $ppr;
                            font-size: 24px / $ppr;
                            box-sizing: border-box;
                        }

                        &.icon-fangxing {
                            top: 20px / $ppr;
                            text-align: center;
                            line-height: 48px / $ppr;
                            height: 48px / $ppr;
                            width: 122px / $ppr;
                            right: 24px / $ppr;
                            border: 1px / $ppr solid #ff6600;
                            color: #ff6600;
                            border-radius: 50px / $ppr;
                            font-size: 24px / $ppr;
                            box-sizing: border-box;
                        }
                    }

                    span {
                        display: inline-block;

                        &.already {
                            position: absolute;
                            right: 30%;
                        }

                        &.preview {
                            color: #5e89ef;
                            position: absolute;
                            right: 45%;
                        }
                    }
                }
            }
        }
    }

    .foot {
        position: fixed;
        bottom: 0;
        width: 100%;

        .bottom_btn {
            width: 100%;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 5;
            font-size: 30px / $ppr;
            text-align: center;

            .left_btn {
                width: 70%;
                float: left;
                background: #f0f0f0;
                color: #333;
                position: relative;

                i {
                    position: absolute;
                    z-index: 1;
                    top: 25px / $ppr;
                    display: inline-block;
                    width: 50px / $ppr;
                    height: 42px / $ppr;
                    background: url("./img/icon1.png") 0 0 no-repeat;
                    background-size: 100% 100%;
                }

                span {
                    font-size: 30px / $ppr;
                    color: #333;
                    display: inline-block;
                    padding-left: 60px / $ppr;
                }
            }

            .right_btn {
                width: 30%;
                float: right;
            }

            .able {
                color: #fff;
                background: #5e89ef;
            }

            .disable {
                color: #fff;
                background: #999;
            }
        }
    }
}
</style>
